// src/components/layout/AppLayout.js

import React from 'react';
import { Box, IconButton, CssBaseline, useTheme, alpha } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './Sidebar';
import Footer from './Footer';
import PageBreadcrumbs from './PageBreadcrumbs';
import { SidebarContextProvider, useSidebarContext } from './SidebarContext';

function AppLayoutInner({ children }) {
  const theme = useTheme();
  const { drawerOpen, handleDrawerToggle, sidebarWidth, isSmDown } = useSidebarContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        {/* サイドバー */}
        <Sidebar open={drawerOpen} handleDrawerToggle={handleDrawerToggle} />

        {/* モバイル用フローティングハンバーガーボタン */}
        {isSmDown && (
          <IconButton
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            sx={{
              position: 'fixed',
              top: 12,
              right: 12,
              zIndex: theme.zIndex.drawer + 1,
              bgcolor: alpha(theme.palette.background.paper, 0.9),
              backdropFilter: 'blur(8px)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
              color: theme.palette.primary.main,
              '&:hover': {
                bgcolor: theme.palette.background.paper,
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* メインコンテンツ */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isSmDown ? 1 : 3,
            pt: isSmDown ? 7 : 3,
            transition: theme.transitions.create(['margin', 'width'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: isSmDown ? 0 : `${sidebarWidth}px`,
            position: 'relative',
            minHeight: 0,
          }}
        >
          <PageBreadcrumbs />
          {children}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

function AppLayout({ children }) {
  return (
    <SidebarContextProvider>
      <AppLayoutInner>{children}</AppLayoutInner>
    </SidebarContextProvider>
  );
}

export default AppLayout;
export { useSidebarContext } from './SidebarContext';
